<template>
  <div>
    <div class='line'></div>
    <ul class='my-12'>
      <li>
        <button
          class='button tooltipped tooltipped-n'
          :aria-label="$t('部材の配置を自動で設定します')"
          @click.prevent.stop='$emit("nest")'
        >
          <i v-html='svg.generate'></i><span>{{ $t('自動で並べる') }}</span>
        </button>
      </li>
    </ul>
    <div class='line'></div>
    <ul class='my-12'>
      <li>
        <button
          class='button tooltipped tooltipped-n'
          :aria-label="$t('選択された部材を複製します')"
          @click.prevent.stop='$emit("addPart")'
        >
          <i v-html='svg.addBin'></i><span>{{ $t('部材を複製する') }}</span>
        </button>
      </li>
      <li>
        <button
          class='button tooltipped tooltipped-n'
          :aria-label="$t('選択された部材を削除します')"
          @click.prevent.stop='$emit("removePart")'
        >
          <i v-html='svg.removeBin'></i><span>{{ $t('部材を削除する') }}</span>
        </button>
      </li>
      <li>
        <button
          class='button'
          @click.prevent.stop='$emit("add")'
        >
          <i v-html='svg.addBin'></i><span>{{ $t('板を追加する') }}</span>
        </button>
      </li>
      <li>
        <button
          class='button'
          @click.prevent.stop='$emit("remove")'
        >
          <i v-html='svg.removeBin'></i><span>{{ $t('板を削除する') }}</span>
        </button>
      </li>
      <li>
        <button
          class='button'
          @click.prevent.stop='$emit("undo")'
        >
          <i v-html='svg.undo'></i><span>{{ $t('元に戻す') }}</span>
        </button>
      </li>
      <li>
        <button
          class='button'
          @click.prevent.stop='$emit("redo")'
        >
          <i v-html='svg.redo'></i><span>{{ $t('やり直す') }}</span>
        </button>
      </li>
      <li>
        <button
          class='button'
          @click.prevent.stop='$emit("reset")'
        >
          <i v-html='svg.reset'></i><span>{{ $t('リセット') }}</span>
        </button>
      </li>
      <li class=''>
        <div class='notes'>
          <i v-html='svg.note'></i>
          <a
            href='https://docs.emarf.co/1515709244d280c5b180ca57f2b5c783'
            target='_blank'
            data-ga-click-event="操作方法について"
          >
            {{ $t('操作方法について') }}
          </a>
        </div>
      </li>
    </ul>
    <div class='line'></div>

    <ul class='my-12'>
      <li v-if="isLabMode" class="selection-toggle my-8" >
        <label class="m-0">{{ $t('新バージョンを利用') }}</label>
        <input
          type="checkbox"
          name="use-new-version-step2"
          id="use-new-version-step2"
          v-model="localUseNewApiVersion"
          @change="onNewApiVersionToggle"
        />
        <div class="toggle-btn"></div>
      </li>
      <li>
        <button class='button step' @click.prevent.stop='$emit("next")'><span>{{ $t('加工プレビューに進む') }}</span></button>
      </li>
      <li>
        <button class='button step back' @click.prevent.stop='$emit("prev")'><span>{{ $t('条件設定に戻る') }}</span></button>
      </li>
    </ul>
  </div>
</template>

<script>

import svgAddBin from '@/assets/images/plugin/add-bin.svg';
import svgGenerate from '@/assets/images/plugin/generate.svg';
import svgRedo from '@/assets/images/plugin/redo.svg';
import svgRemoveBin from '@/assets/images/plugin/remove-bin.svg';
import svgReset from '@/assets/images/plugin/reset.svg';
import svgUndo from '@/assets/images/plugin/undo.svg';

import svgNote from '@/assets/images/plugin/note.svg';

export default {
  name: 'PluginStep2Menu',
  components: {
  },
  props: {
    properties: Object,
    isLabMode: Boolean,
    useNewApiVersion: Boolean
  },
  data () {
    return {
      svg: {
        generate: svgGenerate,
        addBin: svgAddBin,
        removeBin: svgRemoveBin,
        undo: svgUndo,
        redo: svgRedo,
        reset: svgReset,
        note: svgNote
      },
      localUseNewApiVersion: this.useNewApiVersion
    };
  },
  watch: {
    useNewApiVersion(newVal) {
      this.localUseNewApiVersion = newVal;
    }
  },
  mounted () {

  },
  methods: {
    onNewApiVersionToggle() {
      this.$emit('changeApiVersion', this.localUseNewApiVersion);
    }
  }
};

</script>

<style lang="scss" scoped>

.my-12 > li.selection-toggle.my-8 {
  width: calc(100% - 40px);
  justify-content: space-between;
  margin-left: 20px;
  margin-right: 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/plugin/PluginStep2Menu.vue